import {mapState} from 'pinia'
import {usePersonalControlsStore} from '@/stores/PersonalControlsStore'
import MixinSwalConfirmation from '@/mixins/swal/MixinSwalConfirmation'

export default {
    computed: {
        ...mapState(usePersonalControlsStore, {
            allowedEdits: 'allowedEdits'
        })
    },
    mixins: [MixinSwalConfirmation],
    methods: {

        /**
         * This method is used to alert the user if edits are not allowed. 
         * @returns {boolean} true if edits are allowed, false if not.
         */
        alertIfEditsNotAllowed() {

            if (!this.allowedEdits) {
                
                this.swalConfirmation({
                    title: this.$gettext('Edits not allowed'),
                    description: this.$gettext('You decided to be able to update your configuration between certain times only. We are presently outside this time range and updating is disabled.'),
                    confirmButtonText: this.$gettext('OK'),
                    showCancelButton: false,
                    showCloseButton: true,
                    showLoaderOnConfirm: false,
                    successCallback: (answer) => {
                        return false;
                    }
                })

                return false;
            }

            return true;

        },
        alertThatSaveIsNotAllowed() {
            this.swalConfirmation({
                title: this.$gettext('Updating is disabled'),
                description: this.$gettext('You decided to be able to update your configuration between certain times only. We are presently outside this time range and updating is disabled. Please try again later.'),
                confirmButtonText: this.$gettext('OK'),
                showCancelButton: false,
                showCloseButton: true,
                showLoaderOnConfirm: false,
                successCallback: (answer) => {
                    return false;
                }
            })
        }
    }
}
